import React from 'react';
import rocksImage from '../assets/rocks.png';
import reefImage from '../assets/reef.png';
import jungleImage from '../assets/jungle.png';
import leafImage from '../assets/leaf.png';
import arbLogo from '../assets/arb_logo.png'; // Import the Arbitrum logo

const FeatureBlocks = () => (
  <div className="feature-blocks">
    <section className="feature-section large large-leaf-background">
      <h2 className="text-4xl font-bold mb-4">A Decentralized Social and Environmental Lending Platform</h2>
      <p>
        GreenLend facilitates peer-to-peer microloans for social and environmental impact projects, leveraging blockchain for transparency, security, and efficiency.
        Our platform empowers individuals and small businesses by providing access to affordable credit, fostering economic growth, and supporting sustainable development initiatives.
        By utilizing smart contracts on the blockchain, we ensure that every transaction is transparent and secure, reducing the risk of fraud and enhancing trust within the community.
        GreenLend is committed to driving positive change through financial inclusion and environmental stewardship, making a lasting impact on underserved communities worldwide.
      </p>
    </section>
    <section className="feature-section small transparent">
      <h3 className="text-2xl font-bold mb-4">300+ Integrations</h3>
      <p>Explore all integrations on the Arbitrum ecosystem.</p>
      <img src={arbLogo} alt="Arbitrum Logo" className="w-full h-auto mt-4" />
    </section>
    <section className="feature-section medium image-container">
      <img src={jungleImage} alt="GreenLend platform" />
    </section>
    <section className="feature-section small transparent">
      <h3 className="text-2xl font-bold mb-4">Funding Opportunities</h3>
      <p>Apply for funding from the GreenLend Grants Program to support your impactful projects.</p>
    </section>
    <section className="text-block transparent">
      <h3 className="text-2xl font-bold mb-4">Governed by the Community</h3>
      <p>GreenLend is managed by a global community of stakeholders through a decentralized autonomous organization (DAO).</p>
    </section>
    <section className="feature-section large image-container">
      <img src={rocksImage} alt="Protocol Governance" />
    </section>
    <section className="text-block transparent">
      <h3 className="text-2xl font-bold mb-4">Sybil</h3>
      <p>Vote on offchain proposals with the Snapshot interface. Votes are weighted by the number of GreenLend tokens.</p>
    </section>
    <section className="feature-section medium">
      <h3 className="text-2xl font-bold mb-4">Development Resources</h3>
      <p>Get started with quick start guides, platform documentation, a Javascript SDK, and fully open source code.</p>
    </section>
    <section className="text-block">
      <h3 className="text-2xl font-bold mb-4">Whitepaper</h3>
      <p>Read the GreenLend whitepaper to understand the latest innovations in our platform.</p>
    </section>
    <section className="feature-section small image-container">
      <img src={reefImage} alt="Github" />
    </section>
    <section className="text-block transparent">
      <h3 className="text-2xl font-bold mb-4">Community</h3>
      <p>Join the GreenLend community and participate in governance, development, and more.</p>
    </section>
  </div>
);

export default FeatureBlocks;
